import { getIdToken } from './auth';

const API = import.meta.env.VITE_API_URL || 'https://api.scrivar.com';

async function authed(path, options = {}) {
  const token = await getIdToken();
  if (!token) throw new Error('Not signed in');
  const res = await fetch(`${API}${path}`, { ...options, headers: { ...(options.headers || {}), 'Content-Type': 'application/json', Authorization: `Bearer ${token}` } });
  if (!res.ok) throw new Error(`Request failed (${res.status})`);
  return res.json();
}

export const supportApi = {
  list: () => authed('/support/tickets'),
  get: (id) => authed(`/support/tickets/${id}`),
  // `meta.appVersion` is optional — its presence is what tells the server this
  // reply came from inside the desktop app (via='app') rather than a browser.
  reply: (id, body, meta = {}) => authed(`/support/tickets/${id}/messages`, {
    method: 'POST',
    body: JSON.stringify({ body, appVersion: meta.appVersion || undefined }),
  }),
};
